<script setup>
import { getRequest, postRequest } from "@/utils/request.js";
import { message } from "ant-design-vue";
import { ref, unref } from "vue";

const title = ref("角色授权");
const open = ref(false);
const confirmLoading = ref(false);

const role = ref({});
const treeData = ref([]);
const rolePermission = ref([]);
const checkedKeys = ref([]);

const handleOpen = (record) => {
  role.value = { ...record };
  loadData();
  open.value = true;
};

const handleClose = () => {
  open.value = false;
};

const loadData = () => {
  getRequest("/permission/treeList").then((response) => {
    if (response.success) {
      treeData.value = response.data;
    }
  });

  getRequest(`/role/getRolePermissionList/${role.value.id}`).then(
    (response) => {
      if (response.success) {
        rolePermission.value = response.data;
        checkedKeys.value = response.data.map((item) => {
          return item.id;
        });
      }
    },
  );
};

const handleConfirm = () => {
  confirmLoading.value = true;
  const unrefCheckedKeys = unref(checkedKeys);
  let checkPermissionIds = [];
  if (unrefCheckedKeys.checked && unrefCheckedKeys.checked.length) {
    checkPermissionIds = unrefCheckedKeys.checked;
  } else {
    checkPermissionIds = unrefCheckedKeys;
  }

  if (Array.isArray(checkPermissionIds)) {
    postRequest("/role/grantPermissionToRole", {
      roleId: role.value.id,
      permissionIds: checkPermissionIds,
    })
      .then((response) => {
        if (response.success) {
          message.success("授权成功");
          handleClose();
        } else {
          message.error("授权失败。" + response.message);
        }
      })
      .finally(() => {
        confirmLoading.value = false;
      });
  } else {
    message.warn("权限数据编辑错误，请检查");
    confirmLoading.value = false;
  }
};

defineExpose({
  handleOpen,
  handleClose,
  title,
});
</script>

<template>
  <a-modal
    width="800px"
    :open="open"
    :title="title"
    :confirm-loading="confirmLoading"
    @cancel="handleClose"
    @ok="handleConfirm"
  >
    <a-form>
      <a-form-item label="角色名称">
        <a-input v-model:value="role.name" disabled />
      </a-form-item>
      <a-form-item label="角色编号">
        <a-input v-model:value="role.code" disabled />
      </a-form-item>
    </a-form>
    <a-card>
      <a-tree
        v-if="treeData.length"
        :treeData="treeData"
        v-model:checkedKeys="checkedKeys"
        :defaultExpandAll="true"
        :fieldNames="{ children: 'children', title: 'name', key: 'id' }"
        :autoExpandParent="true"
        :checkable="true"
        :checkStrictly="true"
      ></a-tree>
    </a-card>
  </a-modal>
</template>

<style scoped lang="scss"></style>
